import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Spin ,Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function Brands() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [brands, setBrands] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editBrand, setEditBrand] = useState(null);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBrands();
    }, []);

    const fetchBrands = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/brands/all`, { headers });
            setBrands(response.data);
            setFilteredBrands(response.data);
        } catch (error) {
            AlertError("Failed to fetch brands");
        } finally {
            setLoading(false);
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (brand) => {
        setEditBrand(brand);
        form.setFieldsValue({
           // brandCode: brand.brandCode,
            brandName: brand.brandName,
            brandActiveStatus: brand.brandActiveStatus === true,
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateBrand = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            const requestData = {
                //brandCode: values.brandCode,
                brandName: values.brandName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/brands/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Brand successfully added!");
                handleCancel();
                fetchBrands();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add brand!");
        }finally {
            setLoading(false);
        }
    };
    const handleUpdateBrand = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const requestData = {
                brandId: editBrand.brandId,
               // brandCode: values.brandCode,
                brandName: values.brandName,
                brandActiveStatus: values.brandActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/brands/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Brand successfully updated!");
                handleCancel();
                fetchBrands();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to update brand!");
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteBrand = async (id) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/brands/delete/${id}`, { headers });
            AlertSuccess("Brand deleted successfully!");
            fetchBrands();
        } catch (error) {
            AlertError("Failed to delete brand!");
        }finally {
            setLoading(false);
        }
    };
    
    const handleFilter = () => {
        setLoading(true);
        let filtered = brands;

        if (selectedBrand) {
            filtered = filtered.filter(brand => brand.brandId === selectedBrand);
        }

        if (keyword) {
            filtered = filtered.filter(brand => brand.brandName.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredBrands(filtered);
       
     setLoading(false);
        
    };

   
    const handleReset = () => {
        setLoading(true);
        setKeyword('');
        setSelectedBrand(null);
        setFilteredBrands(brands);
        setLoading(false);
    };
    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this brand?"
                        onConfirm={() => handleDeleteBrand(record.brandId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Brand Name',
            dataIndex: 'brandName',
            key: 'brandName',
            sorter: (a, b) => a.brandName.localeCompare(b.brandName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'brandActiveStatus',
            key: 'brandActiveStatus',
            render: (brandActiveStatus) => (
                <Tag color={brandActiveStatus === true ? "green" : "red"}>
                    {brandActiveStatus === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>Brands</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        
                        <Typography.Title level={5}>List of Brands</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredBrands}
                            rowKey="brandId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Brand"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateBrand}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="Brand Code"
                        name="brandCode"
                        rules={[
                            { required: true, message: "Brand code is required" },
                            { len: 4, message: "Brand code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="Brand Name"
                        name="brandName"
                        rules={[{ required: true, message: "Brand name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Brand"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateBrand}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="Brand Code"
                        name="brandCode"
                        rules={[{ required: true, message: "Brand code is required" }, { len: 4, message: "Brand code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="Brand Name"
                        name="brandName"
                        rules={[{ required: true, message: "Brand name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="brandActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editBrand?.brandActiveStatus === true} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
        </Spin>
    );
}

export default Brands;